<template>
    <div class="scroll-primary">
      <v-img :src="value.page.pageUrl" class="pdfImg">
          <employment-signed-field v-for="field in fieldsPerPage" :key="field.dataLabel" :value="field"/>
      </v-img>
  </div>
</template>

<script>
import EmploymentSignedField from "./employment-signed-field.vue"

export default {
    components:{
        EmploymentSignedField
    },
    props:{
        value: { type: Object, default: ()=>({}) }
    },
    computed:{
        fieldsPerPage(){
            let fieldArr=[];
            this.value.fields.map((field)=>{
                if(field.page === this.value.page.page) fieldArr.push(field);
            });

            return fieldArr;
        }
    }
}
</script>

<style scoped>
.scroll-primary{
    overflow-y: unset;
    overflow-x: auto;
}
.pdfImg{
    border: 1px solid #ddd;
    border-radius: 6px;
    max-width: unset;
    width: 976px;
    min-width: 976px;
}
</style>